export enum PromotionEffectTypeEnum {
  Absolute = 'absolute',
  Percent = 'percent',
  Fixed = 'fixed',
}
